export default {"src":"/_next/static/media/id.19e278d1.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};